// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__16Dbo","productName":"Table_productName__3PBzF"};